var map = {
	"./emoji-happiest-off.svg": "0275",
	"./emoji-happiest-on.svg": "1925",
	"./emoji-happy-off.svg": "df72",
	"./emoji-happy-on.svg": "aea1",
	"./emoji-neutral-off.svg": "c28b",
	"./emoji-neutral-on.svg": "d871",
	"./emoji-sad-off.svg": "4fe9",
	"./emoji-sad-on.svg": "f736",
	"./emoji-saddest-off.svg": "d5f1",
	"./emoji-saddest-on.svg": "8b21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a342";